export default {
    data () {
        return {
            assetGroups: [],
            loading: false,
            search: ""
        };
    },
    methods: {
        searchAssetGroups (query) {
            this.search = query;
            this.loading = true;
            axios.get("/assets/groups/search", {params: {filter_text: query}})
            .then(response => {
                this.assetGroups = response.data;
                this.loading = false;
            });
        }
    }
};